import {StocksFilter} from "../../../stocks/models/stocks-filter";

export class ChartListProps {
    constructor(public GUID: string, public filter: StocksFilter){
      this.needUpdate = false;
    }
    public needUpdate: boolean;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/chart-list-props.ts